export function setPatientDisplayPrescriptionId(prescriptionId, prescriptionNum) {
  return {
    type: 'SET_PATIENT_DISPLAY_RX',
    prescriptionId,
    prescriptionNum
  }
}

export function initPatientDisplay(patientId) {
  return {
    type: 'INIT_PATIENT_DISPLAY',
    patientId
  }
}

export function clearPatientDisplay() {
  return {
    type: 'CLEAR_PATIENT_DISPLAY'
  }
}

export function resetInjectionData(patientId) {
  return {
    type: 'RESET_INJECTION_DATA',
    patientId
  }
}

export function clearActivateVialsWindow() {
  return {
    type: 'CLEAR_ACTIVATE_VIALS_WIDGET'
  }
}

export function initActivateVialsWindow(patientId, prescriptionId) {
  return {
    type: 'INIT_ACTIVATE_VIALS_WIDGET',
    patientId,
    prescriptionId
  }
}

export function clearNonXISInjectionsWindow() {
  return {
    type: 'CLEAR_NON_XIS_INJECTIONS_WIDGET'
  }
}

export function initNonXISInjectionsWindow(patientId) {
  return {
    type: 'INIT_NON_XIS_INJECTIONS_WIDGET',
    patientId
  }
}

export function clearVialMixingWindow() {
  return {
    type: 'CLEAR_VIAL_MIXING_WIDGET'
  }
}

export function initVialMixingWindow(patientId) {
  return {
    type: 'INIT_VIAL_MIXING_WIDGET',
    patientId
  }
}

export function clearOrderEntryWindow() {
  return {
    type: 'CLEAR_ORDER_ENTRY_WIDGET'
  }
}

export function initOrderEntryWindow(patientId) {
  return {
    type: 'INIT_ORDER_ENTRY_WIDGET',
    patientId
  }
}

export function clearImmunotherapySummaryWindow() {
  return {
    type: 'CLEAR_DEMOGRAPHICS_WIDGET'
  }
}

export function initImmunotherapySummaryWindow(patientId) {
  return {
    type: 'INIT_DEMOGRAPHICS_WIDGET',
    patientId
  }
}

export function clearOverviewWindow() {
  return {
    type: 'CLEAR_OVERVIEW_WIDGET'
  }
}

export function initOverviewWindow(patientId) {
  return {
    type: 'INIT_OVERVIEW_WIDGET',
    patientId
  }
}

export function clearQuestionnaireWindow() {
  return {
    type: 'CLEAR_QUESTIONNAIRE_WIDGET'
  }
}

export function initQuestionnaireWindow(patientId) {
  return {
    type: 'INIT_QUESTIONNAIRE_WIDGET',
    patientId
  }
}

export function clearPrescriptionWindow() {
  return {
    type: 'CLEAR_PRESCRIPTION_WIDGET'
  }
}

export function initPrescriptionWindow(patientId) {
  return {
    type: 'INIT_PRESCRIPTION_WIDGET',
    patientId
  }
}

export function clearPurchaseOrderWindow() {
  return {
    type: 'CLEAR_PURCHASE_ORDER_WIDGET'
  }
}

export function initPurchaseOrderWindow(patientId) {
  return {
    type: 'INIT_PURCHASE_ORDER_WIDGET',
    patientId
  }
}

export function clearInjectionGraphWindow() {
  return {
    type: 'CLEAR_INJECTION_GRAPH_WIDGET'
  }
}

export function initInjectionGraphWindow(patientId, prescriptionId) {
  return {
    type: 'INIT_INJECTION_GRAPH_WIDGET',
    patientId,
    prescriptionId
  }
}

export function clearInjectionWindow() {
  return {
    type: 'CLEAR_INJECTION_WIDGET'
  }
}

export function initInjectionWindow(patientId) {
  return {
    type: 'INIT_INJECTION_WIDGET',
    patientId
  }
}

export function clearInjectionListWindow() {
  return {
    type: 'CLEAR_INJECTIONLIST_WIDGET'
  }
}

export function initInjectionListWindow(patientId) {
  return {
    type: 'INIT_INJECTIONLIST_WIDGET',
    patientId
  }
}

export function clearSkintestWindow() {
  return {
    type: 'CLEAR_SKINTEST_WIDGET'
  }
}

export function initSkintestWindow(patientId) {
  return {
    type: 'INIT_SKINTEST_WIDGET',
    patientId
  }
}

export function clearPatientDetailsWindow() {
  return {
    type: 'CLEAR_PATIENT_DETAILS_WIDGET'
  }
}

export function initPatientDetailsWindow(patientId) {
  return {
    type: 'INIT_PATIENT_DETAILS_WIDGET',
    patientId
  }
}

export function clearInjAdjustWindow() {
  return {
    type: 'CLEAR_INJ_ADJUST_WIDGET'
  }
}

export function initInjAdjustWindow(patientId, prescriptionId) {
  return {
    type: 'INIT_INJ_ADJUST_WIDGET',
    prescriptionId,
    patientId
  }
}

export function clearStandardInjectionWindow() {
  return {
    type: 'CLEAR_STANDARD_INJECTION_WIDGET'
  }
}

export function initStandardInjectionWindow(patientId) {
  return {
    type: 'INIT_STANDARD_INJECTION_WIDGET',
    patientId
  }
}

export function clearTrackingWindow() {
  return {
    type: 'CLEAR_TRACKING_WIDGET'
  }
}

export function initTrackingWindow(patientId) {
  return {
    type: 'INIT_TRACKING_WIDGET',
    patientId
  }
}

export function initQuestionnaireReviewWindow(patientId) {
  return {
    type: 'INIT_QUESTIONNAIRE_REVIEW_WIDGET',
    patientId
  }
}

export function clearQuestionnaireReviewWindow() {
  return {
    type: 'CLEAR_QUESTIONNAIRE_REVIEW_WIDGET'
  }
}

export function initQuestionnaireHistoryWindow(patientId) {
  return {
    type: 'INIT_QUESTIONNAIRE_HISTORY_WIDGET',
    patientId
  }
}

export function clearQuestionnaireHistoryWindow() {
  return {
    type: 'CLEAR_QUESTIONNAIRE_HISTORY_WIDGET'
  }
}

export function initDirectMessageWindow(patientId) {
  return {
    type: 'INIT_DIRECT_MESSAGE_WINDOW',
    patientId
  }
}

export function clearDirectMessageWindow() {
  return {
    type: 'CLEAR_DIRECT_MESSAGE_WINDOW'
  }
}

export function clearReportHistoryWindow() {
  return {
    type: 'CLEAR_REPORTHISTORY_WIDGET'
  }
}

export function initReportHistoryWindow(patientId) {
  return {
    type: 'INIT_REPORTHISTORY_WIDGET',
    patientId
  }
}

export function clearSkinTestHistoryWindow() {
  return {
    type: 'CLEAR_SKINTESTHISTORY_WIDGET'
  }
}

export function initSkinTestHistoryWindow(patientId) {
  return {
    type: 'INIT_SKINTESTHISTORY_WIDGET',
    patientId
  }
}

export function clearSkinTestDetailWindow() {
  return {
    type: 'CLEAR_SKINTESTDETAIL_WIDGET'
  }
}

export function initSkinTestDetailWindow(patientId) {
  return {
    type: 'INIT_SKINTESTDETAIL_WIDGET',
    patientId
  }
}

export function clearSkinTestAntigensWindow() {
  return {
    type: 'CLEAR_SKINTESTANTIGENS_WIDGET'
  }
}

export function initSkinTestAntigensWindow(patientId) {
  return {
    type: 'INIT_SKINTESTANTIGENS_WIDGET',
    patientId
  }
}

export function clearVialsWindow() {
  return {
    type: 'CLEAR_VIALSLIST_WIDGET'
  }
}

export function initVialsWindow(patientId) {
  return {
    type: 'INIT_VIALSLIST_WIDGET',
    patientId
  }
}

export function clearAttachmentsWindow() {
  return {
    type: 'CLEAR_ATTACHMENTSLIST_WIDGET'
  }
}

export function initAttachmentsWindow(patientId) {
  return {
    type: 'INIT_ATTACHMENTSLIST_WIDGET',
    patientId
  }
}

export function clearVialTestListWindow() {
  return {
    type: 'CLEAR_VIALTESTLIST_WIDGET'
  }
}

export function initVialTestListWindow(patientId) {
  return {
    type: 'INIT_VIALTESTLIST_WIDGET',
    patientId
  }
}

export function clearVialTestScoringWindow() {
  return {
    type: 'CLEAR_VIALTESTSCORING_WIDGET'
  }
}

export function initVialTestScoringWindow(patientId) {
  return {
    type: 'INIT_VIALTESTSCORING_WIDGET',
    patientId
  }
}
